module.exports = __webpack_public_path__ + "img/smelter.8615930c.png";